const module = { name: 'shared/global/offerBanner', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


const Selectors = {
    CONTAINER: 'global-offer-banner',
    SLIDE: '.global-offer-banner__slide',
}
function init() {
    debugLog.info(module.name, 'loading');
    const numSlides = document.querySelectorAll(`#${Selectors.CONTAINER} ${Selectors.SLIDE}`).length;
    if (numSlides < 2) {
        debugLog.info(module.name, 'bypassing Splide');
        return;
    }
    fdCarousel.init(Selectors.CONTAINER, {
        gap: 0,
        padding: { left: 0, right: 0 },
        pagination: !isMobile,
        perPage: 1,
        type: 'loop',
    });
}
module.exports = {
    init
};
export default module.exports;